/* eslint-disable @typescript-eslint/no-explicit-any */
import Fuse from 'fuse.js';
import {
  Table,
  TableColumn,
  Select,
  Option,
  DropdownMenu,
  Dropdown
} from 'element-ui';
import footerTeipTable from '@/components/partials/footer-table.vue';
import headerTeipTable from '@/components/partials/header-table.vue';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  components: {
    'el-select': Select,
    'el-option': Option,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'footer-teip-table': footerTeipTable,
    'header-teip-table': headerTeipTable,
  },
  props: {
    propsToSearch: {
      required: true,
      type: Array as PropType<tPropsToSearch>,
    },

    tableColumns: {
      required: true,
      type: [Object, Array] as PropType<tTableColumns>,
    },

    tableData: {
      required: true,
      type: [Object, Array] as PropType<Array<any>>,
    },

    table: {
      type: String,
      default: 'Registros',
    },

    event: {
      type: Boolean,
      default: false,
    },

    dropdown: {
      type: Boolean,
      default: false,
    },

    search: {
      type: Boolean,
      default: true,
    },

    perPage: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    selectedRows: {},
    pagination: {
      perPage: 10,
      currentPage: 1,
      perPageOptions: [10, 25, 50],
      total: 0,
    },
    searchQuery: '',
    searchedData: [] as any,
    fuseSearch: null as any,
  }),
  computed: {
    queriedData(): any {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        if (this.searchQuery) {
          result = [];
        }
      }
      return result.slice(this.from, this.to);
    },

    to(): number {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from(): number {
      return (
        this.pagination.perPage * (this.pagination.currentPage - 1)
      );
    },

    total(): number {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  mounted(): void {
    // Fuse search initialization.
    this.$data.fuseSearch = new Fuse(this.$props.tableData, {
      keys: this.$props.propsToSearch,
      threshold: 0.3,
    });
  },
  methods: {
    handleRowSelected(row: any): void{
      this.$emit('row-select', row);
      this.$emit('input', row);
    },

    selectionChange(selectedRows: any): void {
      this.selectedRows = selectedRows;
    },

    paginationChanged(page: number): void {
      this.pagination.currentPage = page;
    },

    sortChange({ prop, order, }: any): void {
      if (prop) {
        this.tableData.sort((a: any, b: any) => {
          const aVal = a[prop];
          const bVal = b[prop];
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1;
          }
          return bVal - aVal ? 1 : -1;
        });
      } else {
        this.tableData.sort((a: any, b: any) => {
          return a.id - b.id;
        });
      }
    },

    totalToShow(val: number): void {
      this.pagination.perPage = val;
    },
  },
  watch: {
    searchQuery: {
      immediate: true,
      deep: true,
      handler(value: string): void {
        let result = this.$props.tableData;
        if (value !== '') {
          this.$data.pagination.currentPage = 1;
          result = this.$data.fuseSearch.search(this.$data.searchQuery);
        }
        this.$data.searchedData = result;
      },
    },

    tableData: {
      immediate: true,
      deep: true,
      handler(data: Array<string>): void {
        this.searchedData = data;
      },
    },
  },
});
